import $ from "jquery";
import Storage from "@bd-utils/storage";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getRoomStartedAt, getRoomStatus } from "@bd-stores/game-progress";
import {
    addDocument,
    saveFinalRoomAnswers,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";

export class RoomCyclePuzzle extends BD_Component {
    constructor() {
        super();

        this.id = "cycle_puzzle";
        this.templateID = "cycle_puzzle-template";

        this.elms = {
            blur: ".app-blur",
            messageApp: "#messageApp",
            chatItem: ".js-chat-list",
            closeChat: "#closeMessage",
            codeInputPopup: ".js-code-popup",
            openCodeInput: ".js-open-code",
            closeCodeInput: ".js-close-code",
            inputAnswer: ".js-input-answer",
            checkAnswer: ".js-check-button",
            questionWrapper: ".js-question-wrapper",
            messageState: ".js-msg-state",
            console: ".js-console",
            promptAction: ".js-prompt-action",
            cancelPrompt: ".js-cancel-prompt",
            generatePrompt: ".js-generate-prompt",
            saveBtn: ".js-save-btn",
            hintItems: ".js-hints-item",
            hintTimerBox: ".js-hint-timer-box",
            hintTimer: ".js-hint-timer",
            hintCounter: ".js-hint-counter",
        };

        this._events = this.getEvents();

        (this.timeHour = 0), (this.timeMinute = 0);

        this.userAnswer = undefined;

        this.isGenerating = false;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.closeChat,
                handler: this.closeChat,
            },
            {
                event: "click",
                selector: elms.chatItem,
                handler: this.openChat,
            },
            {
                event: "click",
                selector: elms.openCodeInput,
                handler: this.toggleCodeInput,
            },
            {
                event: "click",
                selector: elms.closeCodeInput,
                handler: this.toggleCodeInput,
            },
            {
                event: "keypress",
                selector: elms.inputAnswer,
                handler: this.inputAnswer,
            },
            {
                event: "click",
                selector: elms.checkAnswer,
                handler: this.checkAnswer,
            },
            {
                event: "click",
                selector: elms.promptAction,
                handler: this.togglePromptText,
            },
            {
                event: "click",
                selector: elms.cancelPrompt,
                handler: this.cancelPrompt,
            },
            {
                event: "click",
                selector: elms.generatePrompt,
                handler: this.generatePrompt,
            },
            {
                event: "click",
                selector: elms.saveBtn,
                handler: this.onAddDocument,
            },

        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        // this.startClock();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            return {
                ...hint,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {
        const elms = this.elms;
        const hasOpen = $(elms.codeInputPopup).hasClass("is-open");
        const isOpen = !hasOpen;

        $(elms.codeInputPopup).toggleClass("is-open", isOpen);
        $(elms.blur).toggleClass("is-blurred", isOpen);
        $(".timer").toggleClass("is-top", isOpen);
    }

    setGameState() {
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if(!this.isGenerating) {
            const savedPrompts = this.getSavedPrompt();
            if(savedPrompts.length > 0) {
                const $innerChat = $(".js-chat-inner");
                const $itemToClone = $(".js-chat-item-cloned");
                const $lastChat = $(".js-chat-inner:last-child");

                $.each(savedPrompts, function(index, prompt) {
                    // prompt from user
                    const $promptFromUser = $itemToClone.clone();
                    $promptFromUser.removeClass("to-be-cloned js-chat-item-cloned");
                    $promptFromUser.addClass("js-chat-item from-user").attr("data-id", prompt.id);
                    $promptFromUser.find(".js-prompt-content-txt").html(prompt.fromUser);
                    $lastChat.append($promptFromUser);
                    $innerChat.animate({scrollTop: $innerChat.prop("scrollHeight")});

                    // standard chat item
                    const $standardChatItem = $itemToClone.clone();
                    $standardChatItem.removeClass("to-be-cloned js-chat-item-cloned");
                    $standardChatItem.addClass("js-chat-item content-text").attr("data-id", prompt.id);
                    $standardChatItem.find(".js-prompt-content-txt").html(prompt.stdMsg);
                    $lastChat.append($standardChatItem);
                    $innerChat.animate({scrollTop: $innerChat.prop("scrollHeight")});

                    // content item
                    const $contentItem = $standardChatItem.clone();
                    $contentItem.attr("data-type", prompt.type);
                    $contentItem.attr("data-title", prompt.title);
                    $contentItem
                        .find(".js-generate-prompt")
                        .attr("data-prompt-text", prompt.regenerateBtn);

                    if(prompt.type === "image") {
                        const imageUrl = prompt.image;
                        $contentItem.removeClass("content-text");
                        $contentItem.addClass("content-item content-image");
                        $contentItem.find(".js-prompt-content-img img").attr("src", imageUrl);
                    } else {
                        const contentText = prompt.text;
                        $contentItem.addClass("content-item content-text");
                        $contentItem.find(".js-prompt-content-txt").html(contentText);
                    }

                    $lastChat.append($contentItem);
                    $innerChat.animate({scrollTop: $innerChat.prop("scrollHeight")});
                });
            }
        }

        this.handleHintVisibility();
    }

    handleHintVisibility() {
        const elms = this.elms;
        const $hintItems = $(elms.hintItems);
        const hintCount = $hintItems.length;
        let currentHintIndex = 0;
        const $firstHint = $hintItems.first();
        let hintTimerToActive = Number($firstHint.attr("data-timer"));
        const roomStartedAt = getRoomStartedAt(this.roomId, CONFIG.user.id);
        if(!roomStartedAt) return;

        if(hintCount === 0) return;

        if(this.hintInterval) {
            clearInterval(this.hintInterval);
            this.hintInterval = null;
        }

        const checkHints = () => {
            const now = Date.now();
            const minutesPassed = Math.floor((now - roomStartedAt) / 60000); //convert ms to minutes
            // let hintActiveId = null;

            $hintItems.each(function (index) {
                const $this = $(this);
                const hintTimer = Number($this.attr("data-timer"));
                if(minutesPassed >= hintTimer) {
                    // $hintItems.addClass("hidden");
                    $this.removeClass("hidden");
                    // hintActiveId = $this.attr("data-id");
                    const $nextHint = $this.next();
                    hintTimerToActive = $nextHint.length ? Number($nextHint.attr("data-timer")) : 0;
                    currentHintIndex = index + 1;
                }
            });

            if(hintTimerToActive > 0) {
                const nextHintTimer = hintTimerToActive;
                const nextHintTimerInMs = (nextHintTimer * 60000 + roomStartedAt) - now;
                const minutesToNextHint = Math.floor(nextHintTimerInMs / 60000);
                const secondsToNextHint = Math.floor((nextHintTimerInMs % 60000) / 1000);
                const minutesTxt = minutesToNextHint < 10 ? `0${minutesToNextHint}` : minutesToNextHint;
                const secondsTxt = secondsToNextHint < 10 ? `0${secondsToNextHint}` : secondsToNextHint;
                const nextHintTimerText =  `${minutesTxt}:${secondsTxt}`;

                $(elms.hintTimer).text(nextHintTimerText);
            }

            const nextHintCounter = `${currentHintIndex}/${hintCount}`;
            $(elms.hintCounter).text(nextHintCounter);

            // if last hint, hide timer box and clear interval
            if(currentHintIndex === hintCount) {
                $(elms.hintTimerBox).addClass("hidden");
                clearInterval(this.hintInterval);
            }
        }

        // Run immediately on page load
        checkHints();

        // Run every seconds
        this.hintInterval = setInterval(checkHints, 1000);
    }

    startClock() {
        let self = this;

        if (this.interval) {
            return false;
        }

        const timeSteps = this._data.time_steps;
        const minTime = this._data.min_time;
        const maxTime = this._data.max_time;

        self.timeHour = minTime;

        const updateTime = function (hour, minute) {
            const txthours = hour.toString().padStart(2, "0");
            const txtMinutes = minute.toString().padStart(2, "0");

            $("#timeHolder__time").text(`${txthours}:${txtMinutes}`);
        };

        updateTime(self.timeHour, self.timeMinute);

        this.interval = setInterval(() => {
            self.timeMinute += timeSteps;

            if (self.timeMinute >= 60) {
                const currentMinutes = Math.floor(self.timeMinute % 60);
                self.timeMinute = currentMinutes;

                self.timeHour++;

                if (self.timeHour == maxTime + 1) {
                    self.timeHour = minTime;
                }
            }

            updateTime(self.timeHour, self.timeMinute);
        }, 1000);
    }

    // ============================== CUSTOM FUNCTION

    closeChat() {
        $(this.elms.messageApp).removeClass("inMessage");
    }

    openChat(e, el) {
        const self = this;
        const $el = $(el);
        const elms = self.elms;
        const itemID = $el.attr("data-id");
        const $chatItem = $(`.chatItem[data-id="${itemID}"]`);
        const $stateImages = $chatItem
            .find(elms.messageState)
            .addClass("hidden")
            .css("display", "none");
        let $activeImage = $();

        $.each($stateImages, function (index, msg) {
            const $msg = $(msg);

            if (index == 0) $activeImage = $msg;

            const startTime = Number($msg.attr("data-start"));
            const endTime = Number($msg.attr("data-end"));
            const isActive = self.isActiveImageState(startTime, endTime);

            if (isActive) {
                $activeImage = $msg;
                return false;
            }
        });

        $chatItem.siblings().removeClass("active");
        $chatItem.addClass("active");
        $activeImage.removeClass("hidden").removeAttr("style");

        $("#messageUserName").text($activeImage.attr("data-title"));
        $(elms.messageApp).addClass("inMessage");
    }

    isActiveImageState(startTime, endTime) {
        let activeHours = [];

        for (let index = startTime; index <= endTime; index++) {
            if (startTime == 24) {
                startTime = 0;
            }

            activeHours.push(startTime);
            startTime++;
        }

        return $.inArray(this.timeHour, activeHours) !== -1 ? true : false;
    }

    inputAnswer(e, el) {
        e.preventDefault();

        const $el = $(el);
        const $questionWrapper = $el.parents(this.elms.questionWrapper);
        const $questionPopup = $el.parents(this.elms.codeInputPopup);

        if ($questionWrapper.hasClass("is-completed")) {
            return false;
        }

        const regex = new RegExp("^[a-zA-Z0-9]+$");
        const key = String.fromCharCode(!e.keyCode ? e.which : e.keyCode);
        if (!regex.test(key)) {
            this.toggleCheckButton();
            return false;
        }

        const value = String($el.val(e.key));
        const $current = $el.parent();
        const $nextInput = $current.next();

        if (value.trim() !== "" && $nextInput.length) {
            $nextInput.find("input").trigger("focus");
        }

        $questionWrapper.removeClass("incorrect");
        $questionPopup.removeClass("is-wrong");

        this.toggleCheckButton();
    }

    toggleCodeInput() {
        const elms = this.elms;
        const hasOpen = $(elms.codeInputPopup).hasClass("is-open");
        const isOpen = !hasOpen;

        $(elms.codeInputPopup).toggleClass("is-open", isOpen);
        $(elms.blur).toggleClass("is-blurred", isOpen);
        $(".timer").toggleClass("is-top", isOpen);
    }

    toggleCheckButton() {
        const $checkBtn = $(this.elms.checkAnswer);
        const $answers = $(this.elms.inputAnswer);
        let isAllFilled = true;

        $.each($answers, function (index, elAnswer) {
            const answer = String($(elAnswer).val());

            if (answer.trim() == "") {
                isAllFilled = false;
                return false;
            }
        });

        $checkBtn
            .prop("disabled", !isAllFilled)
            .toggleClass("valid", isAllFilled);
    }

    checkAnswer(e, el) {
        const elms = this.elms;
        const $el = $(el);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        const $questionWrapper = $(elms.questionWrapper);
        const $codePopup = $(elms.codeInputPopup);
        const $answers = $(elms.inputAnswer);

        $el.addClass("is-loading").prop("disabled", true);
        $questionWrapper.removeClass("incorrect is-correct");

        const roomId = this.roomId;
        const roomAnswers = getRoomAnswerById(roomId);
        let roomStatus = "is-status-started";
        let isCorrect = false;
        let answerData = "";

        $.each($answers, function (index, answer) {
            const $answer = $(answer);
            answerData += $answer.val();
        });

        if (roomAnswers.code == answerData) isCorrect = true;

        if (isCorrect) {
            roomStatus = "is-status-completed";

            const onSuccess = () => {
                $questionWrapper.addClass("is-correct");
                $codePopup.addClass("is-correct");
                $(".app__page").addClass("is-room-completed");
                $el.removeClass("is-loading");
            };

            const onError = () => {};

            saveFinalRoomAnswers(roomId, answerData)
                .then(onSuccess)
                .catch(onError);
        } else {
            $questionWrapper.addClass("incorrect");
            $codePopup.addClass("is-wrong");
            $el.removeAttr("disabled").removeClass("is-loading");
        }

        this.updateUserAnswer(answerData);

        maybeUpdateRoomStatus(roomId, roomStatus);
    }

    togglePromptText(e) {
        const elms = this.elms;
        const $console = $(elms.console);
        const $this = $(e.currentTarget);
        const type = $this.attr("data-type");
        const promptText = $this.attr("data-prompt-text");
        const $promptTxtPreview = $(".js-prompt-text");
        
        $promptTxtPreview.html(promptText);
        $console.attr("data-content-type", type);
        $console.toggleClass("is-prompt-active");
    }

    cancelPrompt() {
        const elms = this.elms;
        const $console = $(elms.console);
        $console.removeClass("is-prompt-active");
    }

    generatePrompt(e) {
        const $this = $(e.currentTarget);
        const isRegenerateBtn = $this.hasClass("btn-regenerate");
        const elms = this.elms;
        const $console = $(elms.console);
        const $innerChat = $(".js-chat-inner");
        let selectedType = "";

        if($this.hasClass("btn-regenerate")) {
            selectedType = $this.parents(".js-chat-item").attr("data-type");
        } else {
            selectedType = $console.attr("data-content-type");
        }

        const $newChatItem = $(".js-chat-item-cloned").clone();
        let promptTxtFromUser;

        if(isRegenerateBtn) {
            promptTxtFromUser = $this.attr("data-prompt-text");
        } else {
            promptTxtFromUser = $(".js-prompt-text").text();
        }
        
        const $lastChat = $(".js-chat-inner:last-child");

        $console.removeClass("is-prompt-active");
        $newChatItem.removeClass("to-be-cloned js-chat-item-cloned");
        $newChatItem.addClass("js-chat-item from-user");
        $newChatItem.find(".js-prompt-content-txt").html(promptTxtFromUser);

        $lastChat.append($newChatItem);
        $innerChat.animate({scrollTop: $innerChat.prop("scrollHeight")});
        
        setTimeout(() => {
            this.generatePromptFromAI(promptTxtFromUser,selectedType);
        }, 1500);

        this.isGenerating = true;
    }

    generatePromptFromAI(promptTxtFromUser, type) {
        const {items} = this._data;
        const selectedType = items.filter((item) => item.type === type);
        const $innerChat = $(".js-chat-inner");

        const $shownContent = $(".js-chat-item").not(".from-user").last();
        const shownContentId = $shownContent.attr("data-id");
        const shownContentIndex = selectedType.map(item => item.item_id).indexOf(shownContentId);
        const contentToShow = 
            (shownContentIndex !== -1 
                && shownContentIndex < selectedType.length - 1) 
                ? selectedType[shownContentIndex + 1] 
                : selectedType[0];

        const $standardChatItem = $(".js-chat-item-cloned").clone();
        const $lastChat = $(".js-chat-inner:last-child");

        $standardChatItem.removeClass("to-be-cloned js-chat-item-cloned");
        $standardChatItem.addClass("js-chat-item content-text").attr("data-id", contentToShow.item_id);
        $standardChatItem.find(".js-prompt-content-txt").html(contentToShow.standard_text);

        const $contentItem = $standardChatItem.clone();
        $contentItem.attr("data-type", type);
        $contentItem.attr("data-title", contentToShow.title);
        $contentItem
            .find(".js-generate-prompt")
            .attr("data-prompt-text", contentToShow.regenerate_button_response_text)

        if(type === "image") {
            const imageUrl = contentToShow.file_image;
        
            $contentItem.removeClass("content-text");
            $contentItem.addClass("content-item content-image");
            $contentItem.find(".js-prompt-content-img img").attr("src", imageUrl);
        } else {
            const contentText = contentToShow.response_text;

            $contentItem.addClass("content-item content-text");
            $contentItem.find(".js-prompt-content-txt").html(contentText);
        }

        const promptData = {
            id: contentToShow.item_id,
            fromUser: promptTxtFromUser,
            stdMsg: contentToShow.standard_text,
            type: type,
            title: contentToShow.title,
            image: contentToShow.file_image,
            text: contentToShow.response_text,
            time: Date.now(),
            regenerateBtn: contentToShow.regenerate_button_response_text,
        };

        this.savePrompt(promptData);
        
        $lastChat.append($standardChatItem);
        setTimeout(() => {
            $lastChat.append($contentItem);
            $innerChat.animate({scrollTop: $innerChat.prop("scrollHeight")});
        }, 1000); 
    }

    savePrompt(data) {
        let savedPrompts = this.getSavedPrompt();
        
        savedPrompts.push(data);
        this.setSavedPrompt(savedPrompts);
    }

    setSavedPrompt(data) {
        const roomId = this.roomId;
        const states = Storage.get("states", {});
        if (!states?.answers) states.answers = {};
        if (!states?.answers?.[roomId]) states.answers[roomId] = [];
        states.answers[roomId] = data;

        return Storage.set("states", states);
    }

    getSavedPrompt() {
        const roomId = this.roomId;
        const states = Storage.get("states", {});
        return states?.answers?.[roomId] || [];
    }

    updateUserAnswer(answerData) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        updateRoomAnswer(roomId, {
            [currentPlayerId]: {
                user_id: currentPlayerId,
                choice: answerData,
            },
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const users = onlinePlayers.map((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "string") {
                    return;
                }

                const user = {
                    ...player,
                    answer: thisPlayerAnswer,
                };

                return user;
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }

    createTitleFromParagraph(paragraph, maxWords = 7) {
        // Remove HTML tags and trim whitespace
        const cleanText = paragraph.replace(/<\/?[^>]+(>|$)/g, "").trim();
      
        // Split into words and limit to maxWords
        const words = cleanText.split(/\s+/).slice(0, maxWords);
      
        // Capitalize the first letter of each word
        const title = words.map(word => 
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(' ');
      
        return title;
    }

    onAddDocument(e) {
        const $this = $(e.currentTarget);
        const $item = $this.parents(".js-chat-item");
        const id = $item.attr("data-id");
        const type = $item.attr("data-type");
        let title = $item.attr("data-title");
        let url = "", text = "";

        if(type === "image") {
            url = $item.find(".js-prompt-content-img img").attr("src");
            title = title || "Marketing Image";
        } else {
            text = $item.find(".js-prompt-content-txt").text();
            title = title || this.createTitleFromParagraph(text);
        }

        const docObj = {
            [id]: {
                title,
                url,
                text,
                type
            },
        };

        addDocument(docObj)
            .then(() => {
                $(".js-saved-document-snackbar").addClass("is-open");
                setTimeout(() => {
                    $(".js-saved-document-snackbar").removeClass("is-open");
                }, 3000);
            })
            .catch(() => console.error("failed"));
    }

    beforeDestroy() {
        if(this.hintInterval) clearInterval(this.hintInterval);
        this.isGenerating = false;
    }
}
